import { cn } from '@/lib/utils';

/** A small teal dot: pulsing = "something changed here since you last looked";
 * solid (`pulse={false}`) = "you applied changes here, not yet cleared". */
export function PulseDot({
  className,
  label,
  pulse = true,
}: {
  className?: string;
  label: string;
  pulse?: boolean;
}) {
  return (
    <span className={cn('relative inline-flex h-2.5 w-2.5 shrink-0', className)} title={label}>
      {label ? <span className="sr-only">{label}</span> : null}
      {pulse ? (
        <span
          aria-hidden
          className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[var(--primary)] opacity-60"
        />
      ) : null}
      <span
        aria-hidden
        className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[var(--primary)]"
      />
    </span>
  );
}
